import { createElement, debounce, convertProductBlockIntoSlider } from './globalFunctions'

const manufacturers = document.querySelector('.manufacturers')
const pageContent = document.querySelector('#content')

const handleBrandsPageTop = () => {
	const categoryTitle = document.querySelector('h1.category-title')
	const shpTabsRow = createElement('div', ['shp-tabs-row'], '')
	const allBrandsHeading = createElement('h2', [], window.language === 'cs' ? 'Všechny značky' : 'All brands')
	const brandsPerex = createElement(
		'p',
		['has-line'],
		window.language === 'cs' ? 'Pro zobrazení produktů značky klikněte na její název' : "Click on a brand's name to view its products"
	)

	if (categoryTitle) {
		categoryTitle.textContent = window.language === 'cs' ? 'Značky' : 'Brands'
		categoryTitle.classList.remove('category-title')
		categoryTitle.after(shpTabsRow)
	}
	if (manufacturers) {
		manufacturers.before(allBrandsHeading)
		manufacturers.before(brandsPerex)
	}
	shpTabsRow.innerHTML = `
        <div class="shp-tabs-holder">
            <ul class="shp-tabs">
                <li class="shp-tab active"><a href="#all" class="shp-tab-link">${
					window.language === 'cs' ? 'Všechny značky' : 'All brands'
				}</a></li>
                <li class="shp-tab"><a class="shp-tab-link" href="#more">${
					window.language === 'cs' ? 'Přečtete si více' : 'Read more'
				}</a></li>
            </ul>
        </div>
    `
	allBrandsHeading.id = 'all'
}
const handleNewswrapper = () => {
	const newsWrapper = document.querySelector('#newsWrapper')
	if (newsWrapper) {
		if (window.innerWidth < 768) {
			convertProductBlockIntoSlider(newsWrapper)
		} else if (!document.querySelector('#newsWrapper.show-all')) {
			$('#newsWrapper.slick-initialized').slick('unslick')
			const readMoreSection = document.querySelector('.read-more-section')
			const moreBrandsBtn = createElement('button', ['btn', 'btn-primary'], window.language === 'cs' ? 'Zobrazit více' : 'Show more')
			moreBrandsBtn.id = 'show-more'
			readMoreSection.appendChild(moreBrandsBtn)
			moreBrandsBtn.addEventListener('click', () => {
				newsWrapper.classList.add('show-all')
				moreBrandsBtn.remove()
			})
		}
	}
}

const handleBrandsPageBottom = () => {
	const readMoreSection = createElement('div', ['read-more-section'])
	readMoreSection.innerHTML = `
        <h2 id="more">${window.language === 'cs' ? 'Přečtete si více o značkách' : 'Read more about the brands'}</h2>
        <div class="more-brands-wrapper" id="newsWrapper"></div>
     `
	const moreBrandsWrapper = readMoreSection.querySelector('.more-brands-wrapper')

	if (typeof brandsOverview != 'undefined' && brandsOverview) {
		for (let brandObject in brandsOverview?.brands) {
			if (brandsOverview.brands.hasOwnProperty(brandObject)) {
				let brand = brandsOverview.brands[brandObject]

				const brandWrapper = createElement('div', ['news-item'])
				brandWrapper.innerHTML = `
		        <div class="image">
		            <a href=${brand.odkaz ? brand.odkaz : ''} title="${window.language === 'cs' ? 'Přečíst více o ' : 'Read more about '} ${
					brand.nadpis ? brand.nadpis : ''
				}">
		                <img src=${brand.obrazek ? brand.obrazek : ''} alt="${
					brand.nadpis ? brand.nadpis : ''
				}" width="342" height="320" data-src=${brand.obrazek ? brand.obrazek : ''}>
		            </a>
		        </div>
		        <div class="text">
		            <a href=${brand.odkaz ? brand.odkaz : ''} class="title">
		            ${brand.nadpis ? brand.nadpis : ''}
		            </a>
		            <div class="description">
		                <p>${brand.perex ? brand.perex : ''}</p>
		             </div>
		            <a class="read-article" href=${brand.odkaz ? brand.odkaz : ''}>${window.language === 'cs' ? 'Přečíst článek' : 'Read more'}</a>
		        </div>
		    `
				moreBrandsWrapper.appendChild(brandWrapper)
			}
		}
		if (manufacturers) {
			manufacturers.after(readMoreSection)
		} else if (pageContent) {
			pageContent.appendChild(readMoreSection)
		}
	}
}
export { handleBrandsPageTop, handleBrandsPageBottom, handleNewswrapper }
